import Vue from "vue";
import Vuex from "vuex";
import { CookieKeys, Cookies } from "../utils/cookieKey";

Vue.use(Vuex);
const userInfo = Cookies.get(CookieKeys.userInfo)
  ? JSON.parse(Cookies.get(CookieKeys.userInfo))
  : {
      userId: "",
      dwmc: "",
      linkName: "",
      zhiwu: "",
    };
const wapGjxx = {
  namespaced: true,
  state: {
    otherObj: {},
    listObj: {},
    userInfo: userInfo,
  },
  getters: {
    otherObj: (state) => state.otherObj,
    listObj: (state) => state.listObj,
    userInfo: (state) => state.userInfo,
  },
  mutations: {
    updateData(state, data) {
      for (const key in data) {
        state[key] = data[key];
      }
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {},
};
export default new Vuex.Store({
  modules: {
    wapGjxx,
  },
});
